import { TaxrateDto } from '@symphony-solo/domain/taxrates/src';
import { TransactionProduct, TransactionProductUnitPrice } from '../models';

export class TransactionProductBuilder {
  private transactionProduct: TransactionProduct;

  constructor() {
    this.transactionProduct = new TransactionProduct();
  }

  public setId(id: number): TransactionProductBuilder {
    this.transactionProduct.id = id;
    return this;
  }

  public setName(name: string): TransactionProductBuilder {
    this.transactionProduct.name = name;
    return this;
  }

  public setPrice(price: TransactionProductUnitPrice): TransactionProductBuilder {
    this.transactionProduct.price = price;
    return this;
  }

  public setQuantity(quantity: number): TransactionProductBuilder {
    this.transactionProduct.quantity = quantity;
    return this;
  }

  public setLineIsCorrected(lineIsCorrected: boolean): TransactionProductBuilder {
    this.transactionProduct.lineIsCorrected = lineIsCorrected;
    return this;
  }

  public setTaxRate(taxRate: TaxrateDto): TransactionProductBuilder {
    this.transactionProduct.taxRate = taxRate;
    return this;
  }

  public setTaxAmount(taxAmount: number): TransactionProductBuilder {
    this.transactionProduct.taxAmount = taxAmount;
    return this;
  }

  public build(): TransactionProduct {
    return this.transactionProduct;
  }
}
